import React from 'react';
import { AlertTriangle, Check, Dot, Info, X } from 'lucide-react';
import { CM_METHODOLOGY } from '../../data/ipoReviewsData';

const BAND_STYLES = {
  must: {
    card: 'border-emerald-200 bg-emerald-50/50',
    badge: 'bg-emerald-600',
    verdict: 'text-emerald-700',
    detail: 'text-emerald-700/80',
    footer: 'text-emerald-700',
    icon: Check,
  },
  may: {
    card: 'border-amber-200 bg-amber-50/50',
    badge: 'bg-amber-500',
    verdict: 'text-amber-700',
    detail: 'text-amber-700/80',
    footer: 'text-amber-700',
    icon: Dot,
  },
  high: {
    card: 'border-violet-200 bg-violet-50/50',
    badge: 'bg-violet-600',
    verdict: 'text-violet-700',
    detail: 'text-violet-700/80',
    footer: 'text-violet-700',
    icon: AlertTriangle,
  },
  avoid: {
    card: 'border-rose-200 bg-rose-50/50',
    badge: 'bg-rose-600',
    verdict: 'text-rose-600',
    detail: 'text-rose-600/80',
    footer: 'text-rose-600',
    icon: X,
  },
};

export const RatingMethodologyGuide = () => (
  <section aria-labelledby="cm-methodology-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-2 pb-4 border-b border-slate-100">
      <div className="flex items-start gap-3">
        <span className="w-9 h-9 rounded-xl bg-teal-50 text-[#008080] border border-teal-100 flex items-center justify-center shrink-0" aria-hidden="true">
          <Info className="w-4 h-4" />
        </span>
        <div>
          <h2 id="cm-methodology-heading" className="text-sm font-extrabold text-slate-900">
            Capital Market (CM) Rating &amp; Research Methodology Guide
          </h2>
          <p className="text-xs text-slate-500">How institutional analysts evaluate SME and Mainboard public offerings</p>
        </div>
      </div>
      <p className="text-[11px] italic text-slate-400 md:text-right">Source: Capital Market Research &amp; SEBI Advisory Guidelines</p>
    </div>

    <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3">
      {CM_METHODOLOGY.map((item) => {
        const styles = BAND_STYLES[item.band];
        const Icon = styles.icon;
        return (
          <li key={item.band} className={`flex flex-col rounded-xl border p-3.5 sm:p-4 ${styles.card}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <span className={`px-2 py-0.5 rounded-md text-[11px] font-extrabold text-white ${styles.badge}`}>{item.range}</span>
              <span className={`text-[10px] font-extrabold uppercase tracking-wider text-right ${styles.verdict}`}>{item.verdict}</span>
            </div>
            <p className="mt-2.5 text-xs sm:text-[13px] font-bold text-slate-800">{item.profile}</p>
            <p className={`mt-1 text-[11px] sm:text-xs leading-relaxed ${styles.detail}`}>{item.detail}</p>
            <div className="mt-auto pt-3">
              <p className={`pt-2.5 border-t border-slate-900/5 flex items-center gap-1 text-[11px] font-semibold ${styles.footer}`}>
                <Icon className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
                {item.footer}
              </p>
            </div>
          </li>
        );
      })}
    </ul>
  </section>
);

export default RatingMethodologyGuide;
